exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".st-drop-result>.count-result[data-v-5ab93042]{font-size:16px}.apiResponse[data-v-5ab93042]{position:absolute;top:50%;transform:translateY(-50%);right:50%;margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AppGetPosts.vue?vue&type=style&index=0&id=5ab93042&scoped=true&lang=css&
// module id = 161
// module chunks = 0